<mat-toolbar class="background-color-green" style=" position: sticky; top: 0;  z-index: 7;">
    <a  routerLink="/">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a>    
    <span class="text-color-white">Achieved Milestone</span>
    <span class="example-spacer"></span>    
    <a  [routerLink]="" (click)="backClicked()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a>
</mat-toolbar>

<div *ngIf="isLoading" class="center">
    <mat-spinner class="example-margin" [color]="color"></mat-spinner>
</div>
<div *ngIf="!isLoading">
    <mat-list role="list">
        @if(milestoneObjectArray.length === 0){
            <span class="text-color-blue" style="font-size: 20px; margin-left: 10px;">{{ 'ml_151232' | translate }}</span>
        }
        @else {
            @for (achievementIdObject of achievementIdObjectMap.values(); track achievementIdObject) {            
                <mat-expansion-panel [expanded]="true" >
                <mat-expansion-panel-header>                    
                    <mat-panel-title class="flex-basis-200px text-color-green">                        
                        {{ achievementIdObject.achievement_Translation_Id  | translate }}
                    </mat-panel-title>
                    <mat-panel-description class="text-color-blue">
                        {{achievementIdObject.milestoneArray.length}}
                    </mat-panel-description>
                </mat-expansion-panel-header>
                @for (milestone of achievementIdObject.milestoneArray; track milestone) {
                    <mat-card class="example-card">
                        <mat-card-header>
                            <mat-card-title>                                
                                <span class="text-color-green">{{ formatDate( milestone.milestoneDate ) }} </span>
                                <span class="example-spacer"></span>
                                <span class="text-color-blue">{{milestone.milestoneName}}</span> 
                            </mat-card-title>
                            <mat-card-subtitle>
                            </mat-card-subtitle> 
                        </mat-card-header>                          
                    </mat-card>
                }
                </mat-expansion-panel>
            }
        }
        
    </mat-list>
</div>
